

<template>
  <div class="ruleManagerList">
    <el-container>
      <el-header>
        <div class="handlePanel">
       
        </div>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="dataTable"
          :data="ruleList"
          highlight-current-row
          size="mini"
          height="100%"
          border
        >
          
          <el-table-column prop="label" label="编码" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="value" label="名称" :show-overflow-tooltip="true"></el-table-column>
           <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="editRuleDetail(scope.row)" type="text" size="small">编辑</el-button>
          </template>
        </el-table-column>
        </el-table>
      </el-main>
    </el-container>

   
  </div>
</template>

<script>
import {
  getRuleService,    //查询通知公告类型
    getRuleDetailService,  //查询通知公告详情
    updateRuleDetailService  //更新通知公告
} from "../../services/sysSettingService";

export default {
  name: "ruleManagerList",
  
  data() {
    return {
      total: 0, //角色总数
      ruleList: [], //可选组织列表
      showUploadDialog: false, //导入工程量清单对话框可见性
      isImportContractDialog: true, //标记为导入工程量清单 false 导入物资采购
      menuRoleCode: "", //授权菜单的roleCode
      pageIndex: 1,
      pageSize: 20     
    };
  },
  props: {
    menuCode: {
      type: String
    }
  },
  methods: {
    //激活时调用
    onActive(menuCode) {
      // this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.pageIndex = 1;
      this.pageSize = 20;
      this.initList();
    },
    //获取列表
    initList() {
      getRuleService()
        .then(res => {
          if (res.code == 10000000) {
            this.ruleList = res.data;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定"
              });
            }
          }
        })
        .catch(error => {
          this.$message.error("系统异常");
        });
    }, 
     //查看子分类一条数据详情
    editRuleDetail(row) {
      this.$confirm("确定要编辑吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {       
         this.bus.$emit("navMenuChange", {
          routeId: "editrulesTab",
          routeParam: {
            label: row.label,
            id:row.id,
            routeId: "editrulesTab"
          }
        });
      });
    },
   
    closeAddDialog() {
      this.$refs.addForm.resetFields();
      this.isAddDialogShow = false;
    }
   
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.ruleManagerList {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.screenPanel {
  text-align: left;
  min-height: 40px;
  padding: 16px 0 0 0;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.el-footer {
  text-align: right;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
